import { render, staticRenderFns } from "./InformesGenerados.vue?vue&type=template&id=4c7def62&scoped=true&"
import script from "./InformesGenerados.vue?vue&type=script&lang=ts&"
export * from "./InformesGenerados.vue?vue&type=script&lang=ts&"
import style0 from "./InformesGenerados.vue?vue&type=style&index=0&id=4c7def62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7def62",
  null
  
)

export default component.exports